import { Environment } from '@environment/interfaces';
import { setEnvironmentVariables } from '@environment/utils/initialize-environment';

export function getGraphQLEndpoint(): string {
  const environment: Environment = setEnvironmentVariables(process.env);
  if (!environment.graphqlApiUrl) {
    throw new Error('GRAPHQL_ENDPOINT not set in .env');
  }
  return environment.graphqlApiUrl;  
}

export function getGraphQLApiKey(): string {
  const environment: Environment = setEnvironmentVariables(process.env);
  if (!environment.graphqlApiUrl) {
    throw new Error('GRAPHQL_API_KEY not set in .env');
  }
  return environment.graphqlApiKey;
}
